import { $host } from "./index";
import jwt_decode from 'jwt-decode';

export const registration = async (email: string, password: string) => {
    const {data} = await $host.post('auth/registration', {email, password}); 
    localStorage.setItem('token', data.token);
    return jwt_decode(data.token);
};

export const login = async (email: string, password: string) => {
    const {data} = await $host.post('auth/login', {email, password});
    localStorage.setItem('token', data.token);    
    return jwt_decode(data.token);
};